import "esbuild-css-modules-plugin-ns-css:src/ui/UIGroup.module.css";

export default {
  "uiGroup": "UIGroup-module__ui-group_WUqfdq__0230"
};
      